import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import {
  antdMessageError,
  antdMessageSuccess,
  buildErrorObject,
  errorHandler,
} from "../../helpers/Utils";
import moment from "moment";

export const getAlsoIncomes =
  (page, per_page, filterParams) => async (dispatch) => {
    try {
      console.time();
      dispatch({ type: "LOADING_CUSTOM" });
      const { data } = await Axios.get(
        `/api/v1/also_incomes.json?page=${page}&per_page=${per_page}${filterParams}`
      );
      console.timeEnd();
      console.log({ data });
      dispatch({
        type: "GET_CUSTOMS",
        payload: { ...data, current: "AlsoIncomes", show_data: data },
      });
      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdMessageError();
      return { success: false };
    }
  };

export const getAlsoIncomesOptions = () => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/also_incomes/managers`);
    if (!data.success) throw new Error("ERR");
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        managers: data.data,
      },
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    return { success: false };
  }
};

export const getAlsoIncome = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/also_incomes/${id}`);
    if (!data) throw new Error("ERR");
    dispatch({
      type: "GET_CUSTOM",
      payload: data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const removeAlsoIncomeItem = (params) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/also_incomes/${params.id}`, {
      data: params,
    });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    await dispatch(getAlsoIncome(params.id));
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const removeAlsoIncome = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/also_incomes/${id}`);
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "GET_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const postAlsoIncome = (params) => async (dispatch) => {
  try {
    const { data } = await Axios.post("/api/v1/also_incomes", {
      also_incomes: params,
    });
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "POST_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return {
      success: false,
      errors: buildErrorObject(err?.response?.data?.errors),
    };
  }
};
export const exportToAlso = async (ids) => {
  try {
    await Axios.post("/api/v1/also_incomes/export_to_also", {
      ids,
    });
    antdMessageSuccess("Exporting to also");
    return { success: true };
  } catch (err) {
    antdMessageError();
    return { success: true };
  }
};

export const exportToErp = async (id = null, ids) => {
  try {
    const { data } = await Axios.post(
      `/api/v1/also_incomes/${id}/export_to_erp`,
      {
        also_income_item_ids: ids,
      }
    );
    antdMessageSuccess("Importing to Rivile");
    if (data.success) {
      return { success: true };
    } else {
      console.log(data.data);
      antdMessageError(data.data);
      return { success: true };
    }
  } catch (err) {
    console.log(err.data);
    antdMessageError(err.data);
    return { success: true };
  }
};

export const alsoIncomeSetStatus = (id, status) => async (dispatch) => {
  try {
    antdAsyncMessageLoading({ key: "set_status" });
    const { data } = await Axios.post(`/api/v1/also_incomes/${id}/set_status`, {
      also_income: {
        status,
      },
    });

    if (data.success) {
      antdAsyncMessageSuccess({ key: "set_status" });
      dispatch({
        type: "GET_CUSTOM",
        payload: data.data,
      });
      return { success: true };
    }
    throw new Error("Err");
  } catch (err) {
    console.log(err.data);
    antdAsyncMessageError({ key: "set_status" });
    return { success: false };
  }
};

export const morelePurchase = (id) => async (dispatch) => {
  try {
    antdAsyncMessageLoading({ key: "morele_purchase" });
    const { data } = await Axios.post(
      `/api/v1/also_incomes/${id}/morele_purchase`
    );

    if (data.success) {
      antdAsyncMessageSuccess({ key: "morele_purchase" });
      dispatch({
        type: "GET_CUSTOM",
        payload: data.data,
      });
      return { success: true };
    }
    throw new Error("Err");
  } catch (err) {
    antdAsyncMessageError({
      key: "morele_purchase",
      text: err?.response?.data?.errors || "Morele purchase failed",
    });
    return { success: false };
  }
};

export const putAlsoIncome = (id, params) => async (dispatch) => {
  try {
    if (!id) return dispatch(postAlsoIncome(params));
    const { data } = await Axios.put(`/api/v1/also_incomes/${id}`, {
      also_incomes: params,
    });
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "GET_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();

    return {
      success: false,
      errors,
    };
  }
};

function transformProductData(product) {
  return {
    order_row_ids: [product.id_order_row || product.id],
    product_title: product.product_name || "Unknown Product",
    quantity: parseFloat(product.quantity) || 0,
  };
}

export const postSupplyingIncome = (params) => async (dispatch) => {
  try {
    const requestData = {
      products: params.orderRows,
      supplier_id: params.supplierId,
      client_shipment_date: moment(params.shipment_date).format("YYYY-MM-DD"),
      warehouse: params.selectedValue,
      has_customs: params.has_customs || false,
      send_email: params.send_email || false,
      review_date: moment(params.review_at).format("YYYY-MM-DD"),
      supply_date: moment(params.supply_date).format("YYYY-MM-DD"),
    };

    if (params.order_nr) {
      requestData.order_nr = params.order_nr;
    }

    if (params.invoice_number !== undefined) {
      requestData.invoice_number = params.invoice_number;
    }

    if (params.id) {
      requestData.id = params.id;
    }

    const { data } = await Axios.post(
      `/api/v1/supplying_incomes/create_po`,
      requestData
    );

    antdMessageSuccess();

    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();

    return {
      success: false,
      errors: err,
    };
  }
};

export const setAlsoIncomeFilters = (filterData) => (dispatch) => {
  dispatch({
    type: "SET_ALSO_INCOME_FILTERS",
    payload: filterData,
  });
};
